<template>
  <div class="settings-form">
    <div class="form-group">
      <label class="form-label">Height</label>
      <input 
        v-model="localSettings.height"
        type="text"
        class="form-input"
        placeholder="20px, 40px, 5rem"
        @input="emitUpdate"
      />
      <p class="form-help-text">Vertical space between elements</p>
    </div>

    <div class="form-group">
      <label class="form-label">Preview</label>
      <div class="spacer-preview" :style="{ height: localSettings.height }">
        <span class="spacer-preview-label">{{ localSettings.height }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  settings: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['update']);

const localSettings = ref({ 
  height: '20px',
  ...props.settings 
});

watch(() => props.settings, (newSettings) => {
  localSettings.value = { ...newSettings };
}, { deep: true });

function emitUpdate() {
  emit('update', localSettings.value);
}
</script>

<style scoped>
.form-help-text {
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.spacer-preview {
  border: 2px dashed #d1d5db;
  border-radius: 4px;
  background: #f9fafb;
  position: relative;
  min-height: 20px;
  max-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spacer-preview-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}
</style>

